import { getCountries } from 'actions/countries';

const countries = () => {
  const initialState = {};

  return (state = initialState, { type, response }) => {
    switch (type) {
      case getCountries.requestTypes.SUCCESS:
        return {
          ...response,
        };
      default:
        return state;
    }
  };
};

export default countries();
